import { TableDataType } from '@spo/logic';
import { Cell, flexRender, Row } from '@tanstack/react-table';
import { VpCheckbox } from '@vtmn-play/react';
import { clsx } from 'clsx';
import { useMemo } from 'react';
import './tableView.scss';

type TableViewRowWithCheckboxProps<T extends TableDataType> = {
  row: Row<T>;
  selectId: (id: string, selectedIds: string[]) => void;
  selectedIds: string[];
  onCellClick?: (row: T) => void;
};
export const TableViewRowWithCheckbox = <T extends TableDataType>({
  row,
  selectId,
  selectedIds,
  onCellClick,
}: TableViewRowWithCheckboxProps<T>) => {
  const isModelChecked = useMemo(
    () => selectedIds.includes(row.original.id),
    [selectedIds, row],
  );

  return (
    <tr
      key={row.id}
      data-testid="table-view-row"
      className={clsx({ 'model-row-checked': isModelChecked })}
    >
      <td key="checkbox-cell" role="gridcell">
        <VpCheckbox
          data-testid="select-model-sm-checkbox"
          id={`select-model-sm-checkbox-${row?.original.id}`}
          checked={isModelChecked}
          onChange={() => {
            selectId?.(row?.original.id, selectedIds);
          }}
        />
      </td>
      {row.getVisibleCells().map((cell: Cell<T, unknown>) => (
        <td
          key={cell.id}
          role="gridcell"
          onClick={() => onCellClick?.(row?.original)}
          onKeyDown={() => onCellClick?.(row?.original)}
        >
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </td>
      ))}
    </tr>
  );
};
